import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Mail } from 'lucide-react';
import NewsletterForm from './NewsletterForm';

const NewsletterCTA: React.FC = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-80px' });

  return (
    <section ref={ref} className="py-16 bg-zinc-900 relative overflow-hidden">
      {/* Background accent */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-2xl h-px bg-gradient-to-r from-transparent via-yellow-400/30 to-transparent" />
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-2xl h-px bg-gradient-to-r from-transparent via-yellow-400/30 to-transparent" />
      </div>
      
      <div className="container-custom relative">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="max-w-4xl mx-auto"
        >
          <div className="relative bg-zinc-950 rounded-3xl border border-zinc-800/60 overflow-hidden">
            {/* Glow effect */}
            <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-96 h-96 bg-yellow-400/5 rounded-full blur-3xl pointer-events-none" />
            
            <div className="relative p-10 md:p-16 grid md:grid-cols-2 gap-10 items-center">
              {/* Left: Content */}
              <div>
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-2xl bg-yellow-400/10 border border-yellow-400/20 mb-6">
                  <Mail className="w-5 h-5 text-yellow-400" />
                </div>
                
                <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 leading-tight">
                  Get the edge on crypto.
                </h2>
                <p className="text-zinc-400 leading-relaxed mb-8">
                  Join 50,000+ Indians getting weekly market analysis, trade setups, and educational content. No hype, no spam.
                </p>
                
                <ul className="space-y-3">
                  {[
                    'Weekly market analysis & trade ideas',
                    'Exclusive educational deep-dives',
                    'Early access to events & workshops',
                  ].map((item, i) => (
                    <li key={i} className="flex items-center gap-3 text-sm text-zinc-300">
                      <div className="w-1.5 h-1.5 rounded-full bg-yellow-400 flex-shrink-0" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>

              {/* Right: Form */}
              <div>
                <div className="bg-zinc-900/80 rounded-2xl p-6 border border-zinc-800/60 backdrop-blur-sm">
                  <h3 className="text-sm font-semibold text-zinc-300 uppercase tracking-wider mb-5">Subscribe free</h3>
                  <NewsletterForm showName />
                </div>
                
                <p className="text-center text-xs text-zinc-600 mt-4">
                  By subscribing you agree to our privacy policy. Unsubscribe anytime.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default NewsletterCTA;
